import { DateRange } from "react-day-picker";

export class SearchData{
    type:string;
    typeOfArticle:string[];
    price:number[] | null;
    roomsRange:number[] | null;
    person:NbrPerson;
    stay:DateRange;
    minSurface:number;
    filters:string[];
    name: string | undefined

    constructor(
        type:string = "weekly",
        typeOfArticle:string[] = [],
        price:null = null,
        roomsRange:number[] | null = null,
        person:NbrPerson = new NbrPerson(),
        stay:DateRange = {from:undefined,to:undefined},
        minSurface:number = 0,
        filters:string[] = [],
        name:string | undefined = undefined

    ){
        this.type = type;
        this.typeOfArticle = typeOfArticle;
        this.price = null;
        this.roomsRange = roomsRange;
        this.person = person;
        this.stay = stay;
        this.minSurface = minSurface;
        this.filters = filters;
        this.name = name;
    }
}

export class NbrPerson {
    adult: number;
    child: number;
    exempt: number;
     
    constructor(
     adult: number = 0,
     child: number = 0,
     exempt: number = 0,
    ) {
     this.adult = adult;
     this.child = child;
     this.exempt = exempt;
    }
}
